function imgPlaceholder() {
    return {
        restrict: "A",
        link: (scope, elem)  => {
            const $img = angular.element(elem[0].getElementsByTagName("img"));
            const $placeholder = angular.element(elem[0].getElementsByClassName("img-placeholder"));

            $img[0].onload = () => {
                $placeholder.css("display", "none");
                $img.css("display", "block");
            };

            scope.$watch(
                () => {
                    return $img.attr("src");
                },
                () => {
                    $placeholder.css("display", "block");
                    $img.css("display", "none");
                });
        }
    };
}

angular
    .module("thor.core.imgPlaceholder.directive", [])
    .directive("imgPlaceholder", imgPlaceholder);
